import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface ColumnPrefs {
  order: string[];
  visibility: Record<string, boolean>;
  widths: Record<string, number>;
  pinLeft: string[];
}

interface ColumnState {
  byScope: Record<string, ColumnPrefs>;
  getPrefs: (scopeKey: string) => ColumnPrefs | undefined;
  setPrefs: (scopeKey: string, prefs: ColumnPrefs) => void;
  patchPrefs: (scopeKey: string, patch: Partial<ColumnPrefs>) => void;
}

const empty: ColumnPrefs = { order: [], visibility: {}, widths: {}, pinLeft: [] };

export const useColumnStore = create<ColumnState>()(
  persist(
    (set, get) => ({
      byScope: {},
      getPrefs: (scopeKey) => get().byScope[scopeKey],
      setPrefs: (scopeKey, prefs) =>
        set((state) => ({ byScope: { ...state.byScope, [scopeKey]: prefs } })),
      patchPrefs: (scopeKey, patch) =>
        set((state) => {
          const current = state.byScope[scopeKey] ?? empty;
          return {
            byScope: {
              ...state.byScope,
              [scopeKey]: {
                order: patch.order ?? current.order,
                visibility: patch.visibility ?? current.visibility,
                widths: patch.widths ?? current.widths,
                pinLeft: patch.pinLeft ?? current.pinLeft,
              },
            },
          };
        }),
    }),
    { name: "coykoi-columns" },
  ),
);
